export function limparCpf(valor) {
  return String(valor || '').replace(/\D/g, '');
}

export function formatarCpf(valor) {
  const digitos = limparCpf(valor).slice(0, 11);

  return digitos
    .replace(/^(\d{3})(\d)/, '$1.$2')
    .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
}

export function validarCpf(valor) {
  const cpf = limparCpf(valor);

  if (cpf.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  const calcularDigito = (tamanho) => {
    let soma = 0;
    for (let i = 0; i < tamanho; i++) {
      soma += Number(cpf[i]) * (tamanho + 1 - i);
    }
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  return (
    Number(cpf[9]) === calcularDigito(9) &&
    Number(cpf[10]) === calcularDigito(10)
  );
}

export function pareceCpf(valor) {
  return /^[\d.\-\s]+$/.test(String(valor || '').trim());
}
